import { Link } from "react-router-dom";

export default function ComplianceFooter() {
  return (
    <footer data-testid="compliance-footer" className="border-t hairline-gold bg-obsidian">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <p className="font-serif text-2xl tracking-[0.2em] uppercase text-amber-100/95 mb-4">
              Monroe <span className="gold-text italic">Society</span>
            </p>
            <p className="text-xs text-neutral-500 leading-relaxed max-w-md">
              Monroe Society is strictly an advertising platform. The platform sells advertising. It does not accept
              or distribute customer payments for providers' services, arrange encounters, negotiate sexual services,
              or act as an escort agency. Any interaction between members and advertisers is undertaken independently
              by those parties.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold/70 mb-4">Join</p>
            <ul className="space-y-2.5 text-sm text-neutral-400">
              <li><Link to="/join/provider" data-testid="footer-provider-link" className="hover:text-gold transition-colors">Provider Sign-Up</Link></li>
              <li><Link to="/join/client" data-testid="footer-client-link" className="hover:text-gold transition-colors">Client Sign-Up</Link></li>
              <li><Link to="/signin" data-testid="footer-signin-link" className="hover:text-gold transition-colors">Sign In</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold/70 mb-4">Legal</p>
            <ul className="space-y-2.5 text-sm text-neutral-400">
              <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-gold transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
              <li><a href="mailto:legal@monroesociety.com" data-testid="footer-legal-email" className="hover:text-gold transition-colors">legal@monroesociety.com</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold/70 mb-4">Contact</p>
            <ul className="space-y-2.5 text-sm text-neutral-400">
              <li><a href="mailto:info@monroesociety.com" className="hover:text-gold transition-colors">info@monroesociety.com</a></li>
              <li><a href="mailto:copyright@monroesociety.com" className="hover:text-gold transition-colors">copyright@monroesociety.com</a></li>
              <li className="text-neutral-500">monroesociety.com</li>
            </ul>
          </div>
        </div>

        <div className="border-t hairline-gold pt-8 space-y-4">
          <div className="flex flex-wrap items-center gap-4">
            <span data-testid="footer-18-badge" className="inline-flex items-center justify-center w-10 h-10 border border-gold/60 text-gold font-serif text-sm font-semibold rounded-full">
              18+
            </span>
            <p className="text-[11px] text-neutral-500 leading-relaxed max-w-3xl">
              This website contains adult content and is intended for adults 18 years of age or older only.
              Minors, trafficking, exploitation, coercion, and nonconsensual content are strictly prohibited and
              reported to the appropriate authorities.
            </p>
          </div>
          <p className="text-[11px] text-neutral-600 leading-relaxed">
            18 U.S.C. §2257 Record-Keeping Requirements Compliance Statement: all advertisers and persons depicted
            in advertisements on this platform were over the age of eighteen at the time of the creation of such
            depictions, and records required by 18 U.S.C. §2257 are maintained by the individual advertisers.
          </p>
          <p className="text-[11px] text-neutral-600 leading-relaxed">
            Colorado SB25-201: beginning July 1, 2026, covered platforms must perform reasonable age verification.
            Monroe Society performs third-party age verification and offers at least one method that verifies age
            without requiring disclosure of identity.
          </p>
          <p className="text-[11px] text-neutral-600">© 2026 Monroe Society. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
